import { createFileRoute } from "@tanstack/react-router";
import { AppointmentsPage } from "@/features/appointments";
import { patientDomainIdFromProfile } from "@/shared/lib/patient-profile";
export const Route = createFileRoute("/_consented/appointments")({ component: Page });
function Page() {
  const { profile } = Route.useRouteContext();
  return <AppointmentsPage patientId={patientDomainIdFromProfile(profile)} />;
}
